import styled from 'styled-components';

const DropboxModal = styled.div``;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-24);
  padding: var(--space-16);
`;

const ModalForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  .input-field {
    label {
      a {
        color: var(--brand-primary);
        text-decoration: none;
      }
      div {
        color: var(--brand-primary);
        cursor: pointer;
        display: initial;
      }
    }
  }
`;

const ModalButton = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: var(--space-12);
`;

export { DropboxModal, ModalButton, ModalContent, ModalForm };
